import React, {Fragment} from "react";
import {connect} from "react-redux";
import {Modal, Button, InputNumber, Alert, message, Tooltip} from "antd";
import Table from "antd/lib/table";
import {createIPAddressModification} from "../../actions/billing";
import {displayErrors} from "../../libs/utils";
import AccessItem from "../permissions/AccessItem";
import {MoneyField} from "../shared/MoneyField";
import moment from "moment";

class ModifyIPAddressesModal extends React.Component {
    state = {
        data: [],
        items: [],
        loading: false
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && this.state.data.length === 0) {
            let data = this.props.ipAddresses.filter(item => this.props.selectedIPAddresses.indexOf(item.guid) !== -1);

            data = data.map((item) => {
                return {...item, new_domains_allowed: item.domains_allowed };
            });

            this.setState({ data });
        }
    }

    updateData(guid, value) {
        let data = this.state.data.map((item) => {
            if(item.guid === guid) {
                return {...item, new_domains_allowed: value };
            }

            return item;
        });

        this.setState({ data });
    }

    closeModal() {
        this.props.close();
        this.setState({ data: [] });
    }

    submitRequest() {
        let data = [];

        for(let i = 0; i < this.state.data.length; i++) {
            if(this.state.data[i].domains_allowed !== this.state.data[i].new_domains_allowed) {
                data.push({
                    ip_address: this.state.data[i].guid,
                    value: this.state.data[i].new_domains_allowed
                })
            }
        }

        if(data.length === 0) {
            return message.error('Please change at least one IP address!');
        }

        this.setState({ loading: true });

        this.props.createIPAddressModification(data, (res) => {
            this.setState({ loading: false });

            if(typeof res.data.invoice_id !== 'undefined') {
                message.success('Success! Redirecting to invoice...', 5);
                this.props.history.push('/billing/invoices/' + res.data.invoice_id);
            } else {
                message.success('Success! IP address changes scheduled!');
            }
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    getCurrentSlotCost(item) {
        if(item.currency === 'EUR') {
            return <Tooltip title={<span>The base rate is in USD. Currency conversion rates are updated daily. Displayed prices are approximate. The final and binding amount is shown on the invoice.</span>}>≈ <MoneyField amount={item.cost.additional_website_slots_total_cost} currency={item.cost.currency} /></Tooltip>
        }

        return <MoneyField amount={item.cost.additional_website_slots_total_cost} currency={item.cost.currency} />
    }

    getIPAddressCost(item) {
        if(item.currency === 'EUR') {
            return <Tooltip title={<span>The base rate is in USD. Currency conversion rates are updated daily. Displayed prices are approximate. The final and binding amount is shown on the invoice.</span>}>≈ <MoneyField amount={item.cost.ip_address_cost} currency={item.cost.currency} /></Tooltip>
        }

        return <MoneyField amount={item.cost.ip_address_cost} currency={item.cost.currency} />
    }

    getNewSlotsCost(item) {
        let totalCost = 0;

        if(item.new_domains_allowed - item.domains_allowed > 0) {
            totalCost = (item.new_domains_allowed - 1) * item.cost.additional_website_slot_cost;
        }

        if(item.currency === 'EUR') {
            return <Tooltip title={<span>The base rate is in USD. Currency conversion rates are updated daily. Displayed prices are approximate. The final and binding amount is shown on the invoice.</span>}>≈ <MoneyField amount={(item.new_domains_allowed - 1) * item.cost.additional_website_slot_cost} currency={item.cost.currency} /></Tooltip>
        }

        return <MoneyField amount={totalCost} currency={item.cost.currency} />
    }

    getIPAddressTotalCost(item) {
        if(item.currency === 'EUR') {
            return <Tooltip title={<span>The base rate is in USD. Currency conversion rates are updated daily. Displayed prices are approximate. The final and binding amount is shown on the invoice.</span>}>≈ <MoneyField amount={((item.new_domains_allowed - 1) * item.cost.additional_website_slot_cost) + item.cost.ip_address_cost} currency={item.cost.currency} /></Tooltip>
        }

        return <MoneyField amount={((item.new_domains_allowed - 1) * item.cost.additional_website_slot_cost) + item.cost.ip_address_cost} currency={item.cost.currency} />
    }

    getDueToday(item, amountOnly= false) {
        const start = moment();
        const end = moment(item.order.renewal_date, "YYYY-MM-DD");

        let years = end.diff(start, 'years');
        start.add(years, 'years')
        let months = end.diff(start, 'months');
        start.add(months, 'months')
        let days = end.diff(start, 'days');
        start.add(days, 'days')

        months = months + (years * 12);
        days = days + 1;

        const costPerDay = item.cost.additional_website_slot_cost / 30;
        const newSlotsCount = (item.new_domains_allowed - item.domains_allowed)

        let dueToday = ((months * item.cost.additional_website_slot_cost) + (days * costPerDay)) * newSlotsCount;

        if(amountOnly) {
            return dueToday;
        }

        if(item.new_domains_allowed - item.domains_allowed === 0) {
            dueToday = 0;
        }

        if(item.currency === 'EUR') {
            return <Tooltip title={<span>The base rate is in USD. The conversion rate is updated daily. The final conversion rate is displayed on an invoice.</span>}>≈ <MoneyField amount={dueToday} currency={item.cost.currency} /></Tooltip>
        }

        return <MoneyField amount={dueToday} currency={item.cost.currency} />
    }

    getDueTodayTotalAmount(items) {
        let dueToday = 0;

        items.forEach((item) => {
            dueToday += this.getDueToday(item, true);
        });

        return <MoneyField amount={dueToday} currency={items[0].cost.currency} />
    }

    render() {
        const columns = [
            { title: 'IP Address', dataIndex: 'ip_address' },
            { title: 'IP Address Cost', align: 'center', render: (item) => this.getIPAddressCost(item) },
            { title: 'Next Renewal Date', align: 'center', render: (item) => moment(item.order.renewal_date).format('YYYY/MM/DD') },
            { title: 'Current Website Slots', align: 'center', dataIndex: 'domains_allowed' },
            { title: 'Current Website Slots Cost', align: 'center', render: (item) => this.getCurrentSlotCost(item) },
            { title: 'Required Slots', align: 'center', render: (item, record) => {
                let maxDomainSlots = 1;

                if(record.ip_address_type === 'DEDICATED') {
                    if(record.domains_allowed > 10) {
                        maxDomainSlots = record.domains_allowed;
                    } else {
                        maxDomainSlots = 10;
                    }
                }

                let minDomainSlots = record.domain_count;

                if(record.domain_count === 1) {
                    minDomainSlots = 1;
                }

                return <InputNumber size='small' value={record.new_domains_allowed} min={minDomainSlots} max={maxDomainSlots} onChange={(value) => this.updateData(record.guid, value)} />
            }},
            { title: 'New Slots Cost', align: 'center', render: (item) => this.getNewSlotsCost(item) },
            { title: 'New Total Cost', align: 'center', render: (item) => this.getIPAddressTotalCost(item) },
            { title: 'Due Today', align: 'center', render: (item) => this.getDueToday(item) }
        ];

        return(
            <Modal
                open={this.props.showModal}
                destroyOnClose={true}
                onCancel={() => this.closeModal()}
                width='100%'
                footer={
                    <Fragment>
                        <Button disabled={this.state.loading} onClick={() => this.closeModal()}>Close</Button>
                        <AccessItem scopes={['can_edit_ip_addresses']}>
                            <Button disabled={this.state.loading} loading={this.state.loading}
                                    onClick={() => this.submitRequest()} type='primary'>Submit</Button>
                        </AccessItem>
                    </Fragment>
                }
                title='Modify IP Address Website Slots'>
                <Alert showIcon type='info'
                       message='Downgrades will be processed at the end of the billing cycle. Upgrades will be processed after the payment is received.'/><br/>
                <div style={{overflowX: 'auto'}}>
                    <Table
                        dataSource={this.state.data}
                        columns={columns}
                        rowKey={(item) => item.guid}
                        summary={pageData => {
                            return <Table.Summary.Row>
                                <Table.Summary.Cell index={0} />
                                <Table.Summary.Cell index={1} />
                                <Table.Summary.Cell index={2} />
                                <Table.Summary.Cell index={3} />
                                <Table.Summary.Cell index={4} />
                                <Table.Summary.Cell index={5} />
                                <Table.Summary.Cell index={6} />
                                <Table.Summary.Cell index={7} />
                                <Table.Summary.Cell index={8} className='text-center'>
                                    <b>{this.getDueTodayTotalAmount(pageData)}</b>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>;
                        }}
                        pagination={false}/>
                </div>
            </Modal>
    );
    }
    }

    export default connect(null, { createIPAddressModification })(ModifyIPAddressesModal);